import { SourcingAnalytics } from 'api-clients/monolith';

import { Skeleton } from '@/components/ui/skeleton';
import { Typography } from '@/components/ui/typography';
import { useCurrencySymbol } from '@/hooks/use-currency-symbol';

import { useMetricContent } from './use-metric-content';

interface MetricIndicatorProps {
  metricKey: keyof SourcingAnalytics;
  value: number | null;
}

const CURRENCY_METRIC_KEYS: ReadonlySet<keyof SourcingAnalytics> = new Set<
  keyof SourcingAnalytics
>(['budget_spent', 'average_cpa', 'average_cph']);

export function MetricIndicator({ metricKey, value }: MetricIndicatorProps) {
  const { label, icon } = useMetricContent({ metricKey });
  const { formatCurrency } = useCurrencySymbol();

  const displayValue =
    value == null
      ? '-'
      : CURRENCY_METRIC_KEYS.has(metricKey)
      ? formatCurrency(value)
      : value;

  return (
    <div className="flex flex-row items-center justify-center gap-4">
      <img src={icon} alt="Metric" className="h-6 w-6" />
      <div className="flex flex-col items-start py-2">
        <Typography variant="subtitle1">{label}</Typography>
        <Typography variant="large2">{displayValue}</Typography>
      </div>
    </div>
  );
}

MetricIndicator.Skeleton = function MetricIndicatorSkeleton({
  metricKey,
}: {
  metricKey: keyof SourcingAnalytics;
}) {
  const { label, icon } = useMetricContent({ metricKey });

  return (
    <div className="flex flex-row items-center justify-center gap-4">
      <img src={icon} alt="Metric" className="h-6 w-6" />
      <div className="flex flex-col items-start py-2">
        <Typography variant="subtitle1">{label}</Typography>
        <Skeleton className="mt-1 h-5 w-8" />
      </div>
    </div>
  );
};
